/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { SCHEDULE_CONFLICT, OVERLAPPING_SHIFTS, UNAVAILABLE } from './classifyDateConflict';
import closeIcon from '../../assets/images/close.svg';
import scheduleConflictIcon from '../../assets/images/event-busy.svg';
import overlappingIcon from '../../assets/images/join-left.svg';
import unavailableIcon from '../../assets/images/beach-access.svg';

const CONFLICTS = {
	[SCHEDULE_CONFLICT]: { classname: 'date-pill--schedule-conflict', icon: scheduleConflictIcon },
	[OVERLAPPING_SHIFTS]: { classname: 'date-pill--overlapping', icon: overlappingIcon },
	[UNAVAILABLE]: { classname: 'date-pill--unavailable', icon: unavailableIcon }
};

/**
 * Renders a single removable date chip in the selected-dates row of the
 * date picker (used by both the Request New Shifts and Bulk Assign tabs).
 *
 * The chip color reflects the conflict type produced by
 * `classifyDateConflict`. The legacy `errors.invalidDate` red-chip behavior
 * on the Request New Shifts tab is the caller's responsibility — pass
 * `SCHEDULE_CONFLICT` as `conflictType` when that legacy condition fires.
 *
 * When `conflictType` is non-null, the chip is wrapped in the project's
 * custom `Tooltip` so hovering shows a short label ("Schedule Conflict",
 * "Overlapping shift", or "Unavailable"). When `conflictType` is null the
 * tooltip wrapper is omitted to avoid an empty hover popup.
 *
 * @param {{
 *   date: (string | Date | import('moment').Moment),
 *   conflictType: ('SCHEDULE_CONFLICT'|'OVERLAPPING_SHIFTS'|'UNAVAILABLE'|null),
 *   onRemove: () => void
 * }} props
 * @returns {React.ReactElement}
 */
const DatePill = ({ date, conflictType, onRemove }) => {
	const momentDate = moment(date);
	const dayOfWeek = momentDate.format('ddd');
	const formattedDate = momentDate.format('MM/DD');

	const conflict = CONFLICTS[conflictType] || {};

	return (
		<div className={classNames('date-pill', conflict.classname)}>
			{conflict.icon && <img src={conflict.icon} alt="close" />}
			<div>
				<b>{dayOfWeek}</b>&nbsp;{formattedDate}
			</div>
			<img src={closeIcon} alt="close" className="remove-date" onClick={onRemove} />
		</div>
	);
};

export default DatePill;
